/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import theme, { Content_Text } from "../Component/theme";

import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";
import img_GTP_logo from "../image/img_GTP_logo.png";
import img_dadem_info2 from "../image/img_dadem2.png";
import img_dadem_info3 from "../image/img_dadem3.png";
import img_dadem_info from "../image/img_dadem_info.png";
import img_dadem_logo from "../image/img_dadem_logo.png";
import img_dron_logo from "../image/img_dron_logo.png";
import img_na_info from "../image/img_na.png";
import img_na_info2 from "../image/img_na2.png";
import img_na_info3 from "../image/img_na3.png";
import img_na_logo from "../image/img_na_logo.png";
import img_naju_logo from "../image/img_naju_logo.png";
import img_naju_train_logo from "../image/img_naju_train_logo.png";
import img_petch_info from "../image/img_petch.png";
import img_petch_info2 from "../image/img_petch2.png";
import img_petch_info3 from "../image/img_petch3.png";
import img_petch_logo from "../image/img_petch_logo.png";
import img_rosepay_logo from "../image/img_rosepay_logo.png";
import img_shopping_logo from "../image/img_shopping_logo.png";

import img_naju_info from "../image/img_naju.png";
import img_naju_info2 from "../image/img_naju2.png";
import img_naju_info3 from "../image/img_naju3.png";

import img_rosepay_info from "../image/img_rosepay_info.png";
import img_rosepay_info2 from "../image/img_rosepay_info2.png";
import img_rosepay_info3 from "../image/img_rosepay_info3.png";

import img_naju_train_info from "../image/img_naju_train_info.png";
import img_naju_train_info2 from "../image/img_naju_train_info2.png";
import img_naju_train_info2_2 from "../image/img_naju_train_info2_2.png";
import img_naju_train_info3 from "../image/img_naju_train_info3.png";
import img_naju_train_info3_2 from "../image/img_naju_train_info3_2.png";
import img_naju_train_info_2 from "../image/img_naju_train_info_2.png";

import img_GTP_info from "../image/img_GTP_info.png";
import img_GTP_info2 from "../image/img_GTP_info2.png";
import img_GTP_info3 from "../image/img_GTP_info3.png";
import img_GTP_info4 from "../image/img_GTP_info4.png";

import img_dron_info from "../image/img_dron_info.png";
import img_dron_info10 from "../image/img_dron_info10.png";
import img_dron_info11 from "../image/img_dron_info11.png";
import img_dron_info2 from "../image/img_dron_info2.png";
import img_dron_info3 from "../image/img_dron_info3.png";
import img_dron_info4 from "../image/img_dron_info4.png";
import img_dron_info5 from "../image/img_dron_info5.png";
import img_dron_info6 from "../image/img_dron_info6.png";
import img_dron_info7 from "../image/img_dron_info7.png";
import img_dron_info8 from "../image/img_dron_info8.png";
import img_dron_info9 from "../image/img_dron_info9.png";

import img_shopping_info from "../image/img_shopping_info.png";
import img_shopping_info2 from "../image/img_shopping_info2.png";
import img_shopping_info3 from "../image/img_shopping_info3.png";
import img_shopping_info4 from "../image/img_shopping_info4.png";
import img_shopping_info5 from "../image/img_shopping_info5.png";
import img_shopping_info6 from "../image/img_shopping_info6.png";
import img_shopping_info7 from "../image/img_shopping_info7.png";

import Footer_FMS from "../2.FMS/Footer_FMS";
import Header_Main from "./Header_Main";

const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 80px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
  @media (max-width: 800px) {
    grid-template-rows: 40px 1fr 400px;
  }
`;
const Header = styled.header`
  grid-area: header;
  background: white;
  display: flex;
  align-items: center;
  border-width: 0px 0px 1px 0px;
  border-color: #e7e7e7;
  border-style: solid;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 10;
  @media (max-width: 800px) {
    padding-left: 15px;
  }
`;
const Header_div = styled.div`
  display: flex;
  color: black;
  align-items: center;
  max-width: 1280px;
  width: 100%;
  padding: 20px;
`;
const Logo_img = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  cursor: pointer;
  margin-right: 50px;
  height: 40px;
  @media (max-width: 800px) {
    margin-right: 30px;
    height: 20px;
  }
`;
const Top_Button = styled.span`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  font-size: 20px;
  margin-left: 30px;
  cursor: pointer;
  transition: color 0.2s ease;
  &:hover {
    color: ${theme.colors.main};
  }
  @media (max-width: 800px) {
    font-size: 12px;
    margin-left: 15px;
  }
`;
const Main = styled.main`
  grid-area: main;
  padding-top: 10px;
  background-color: white;
`;
const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 20px;
`;
const Main_div4 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 20px;
  @media (max-width: 800px) {
    display: none;
  }
`;
const Main_div5 = styled.div`
  display: none;
  justify-content: flex-start;
  @media (max-width: 800px) {
    display: flex;
  }
`;
const Main_div6 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 20px;
  @media (max-width: 1500px) {
    display: none;
  }
  @media (max-width: 800px) {
    display: none;
  }
`;
const Main_div7 = styled.div`
  display: none;
  width: 100%;
  justify-content: center;
  padding-bottom: 20px;
  @media (max-width: 1500px) {
    display: flex;
  }
  @media (max-width: 800px) {
    display: none;
  }
`;
const Main_div8 = styled.div`
  display: none;
  width: 100%;
  justify-content: center;
  padding-bottom: 20px;
  @media (max-width: 1500px) {
    display: none;
  }
  @media (max-width: 800px) {
    display: flex;
  }
`;

const Div_Null = styled.div`
  background-color: white;
  height: 5000px;
`;
const Main_init_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 1500px) {
    padding: 0px 15px 0px 15px;
    padding-top: 50px;
  }
  @media (max-width: 800px) {
    padding: 0px;
    padding-top: 50px;
  }
`;
const Main_init_div3 = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 1500px) {
    padding: 0px 15px 0px 15px;
  }
  @media (max-width: 800px) {
    padding: 0px;
    padding-left: 15px;
  }
`;
const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;
const Main_Content2 = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    display: none;
  }
`;

const Main_Content4 = styled.div`
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Main_Bar = styled.div`
  border-width: 2px 0px 0px 0px;
  border-color: ${theme.colors.bgGray};
  border-style: solid;
  width: 1280px;
  margin: 20px 15px 30px 15px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;
const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 150px;
  margin-bottom: 30px;
  cursor: pointer;
`;
const Image2 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: ${(props) => (props.$large ? "900px" : "800px")};
  margin-bottom: 30px;
  margin-left: ${(props) => (props.$large ? "100px" : 0)};

  @media (max-width: 800px) {
    width: ${(props) => (props.$large ? "90%" : "80%")};
    margin-left: ${(props) => (props.$large ? "10%" : 0)};
  }
`;

const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;
const Footer_Text = styled(Content_Text)`
  margin-top: 5px;
`;

const Footer_Bar = styled.div`
  border-width: 0px 0px 1px 0px;
  border-color: #e7e7e7;
  border-style: solid;
  width: 1280px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;
const Footer_div = styled.div`
  justify-self: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 20%;
  @media (max-width: 800px) {
    width: 40%;
  }
`;
const Footer_Text2 = styled(Content_Text)`
  transition: color 0.2s ease;

  &:hover {
    color: #33cccc;
  }
`;

const Select_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1100px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 800px) {
    display: none;
  }
`;

const Mini_Main_Content = styled.div``;
const Mini_Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 90%;
  cursor: pointer;
  margin-bottom: 10px;
`;
const Title_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 5px;
`;
const Image_div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const Text_div2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  text-align: center;
  margin-bottom: 100px;
`;

const Select_Button = styled.button`
  background-color: ${(props) => (props.$select ? "white" : "#FAFAFA")};
  padding: 6px 0px;
  width: 100%;
  border-radius: 8px;
  border-style: solid;
  border-width: ${(props) => (props.$select ? 1 : 0)}px;
  border-color: ${theme.colors.fontBlue};
  @media (max-width: 800px) {
    padding: 4px 0px;
  }
  cursor: pointer;
`;

const FMS_Coment = styled.span`
  background-color: ${theme.colors.bgGray2};
  padding: 10px 28px;
  border-radius: 20px;
  border-style: solid;
  border-width: 1px;
  border-color: ${theme.colors.barGray};
`;
const FMS_Coment2 = styled.span`
  background-color: ${theme.colors.bgGray2};
  width: 50px;
  height: 28px;
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;
  border-color: ${theme.colors.barGray};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Gray_Box = styled.span`
  background-color: ${theme.colors.bgGray2};
  padding: 5px 10px;
  border-radius: 8px;
  border-style: solid;
  border-width: 0px;
  border-color: ${theme.colors.barGray};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-right: 10px;
  @media (max-width: 800px) {
    display: none;
  }
`;

const Gray_Box2 = styled.span`
  background-color: ${theme.colors.bgGray2};
  /* width: 50px; */
  height: 28px;
  padding: 5px 12px;
  border-radius: 8px;
  border-style: solid;
  border-width: 0px;
  border-color: ${theme.colors.barGray};
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 800px) {
    height: 14px;
  }
`;

const Gray_Box3 = styled.span`
  background-color: ${theme.colors.bgGray2};
  padding: 5px 10px;
  border-radius: 8px;
  border-style: solid;
  border-width: 0px;
  border-color: ${theme.colors.barGray};
  display: none;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-right: 5px;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const PP_Logo = styled(Image)`
  width: 140px;
  height: 100%;
  cursor: pointer;
  margin-right: 20px;
  @media (max-width: 800px) {
    width: 90px;
    margin-right: 8px;
    margin-left: 15px;
  }
`;

const Platform_Name = styled.div`
  display: flex;
  position: relative;
  height: 140px;
  justify-content: space-between;
  @media (max-width: 800px) {
    height: 90px;
  }
`;

const Main_init_div4 = styled.div`
  display: flex;
  width: 200px;
  padding: 8px;
  border-radius: 16px;
  background-color: #fafafa;
  align-items: center;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 800px) {
    padding: 8px;
    width: 130px;
  }
`;

const Main_Content3 = styled.div`
  flex: 1;
  display: flex;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    padding: 0px 2px 0px 2px;
  }
`;

function Platform_Info() {
  const navigation = useNavigate();
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const [sel, set_Sel] = useState("01");
  const open_privacy_policy = () => set_Privacy_Policy(true);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const open_terms = () => set_Terms(true);
  const close_terms = () => set_Terms(false);
  const [select, set_Select] = useState("");
  const [select_pp, set_Select_PP] = useState("");

  const go_Home = () => {
    navigation("/");
  };
  const go_About = () => {
    navigation("/about");
  };
  const go_Info = () => {
    navigation("/Info");
  };
  const go_Platform = (item) => {
    navigation("/Platform", { state: { data: item } });
  };
  const go_Event_About = (item) => {
    navigation("/Event_About");
    window.scrollTo({ top: 0 });
  };
  const location = useLocation();

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const data = location.state;
    if (data && data !== undefined) {
      if (data.data !== undefined) {
        set_Select_PP(data.data);
        if (data.data === "FMS") {
          set_Select("FMS");
        } else {
          set_Select("앱/웹");
        }
      }
    }

    // 사이즈 체크
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = ""; // Chrome에서는 returnValue 설정이 필요합니다.
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header>
        <Header_Main page="포트폴리오" />
      </Header>
      {/* <Sidebar>사이드바 영역</Sidebar> */}
      <Main>
        <Main_div>
          <Main_init_div>
            <Main_Content>
              <Content_Text $xxlarge $xbold>
                포트폴리오
              </Content_Text>
            </Main_Content>
          </Main_init_div>
        </Main_div>
        <Main_div style={{ paddingBottom: 20 }}>
          <Main_init_div4>
            <Main_Content3>
              <Select_Button
                $select={select === "앱/웹"}
                onClick={() => {
                  go_Platform("앱/웹");
                  set_Select_PP("");
                }}
              >
                <Content_Text $blue={select === "앱/웹"} $lightGray>
                  앱/웹
                </Content_Text>
              </Select_Button>
            </Main_Content3>
            <Main_Content3>
              <Select_Button
                $select={select === "FMS"}
                onClick={() => {
                  go_Platform("FMS");
                  set_Select_PP("");
                }}
              >
                <Content_Text $blue={select === "FMS"} $lightGray>
                  FMS
                </Content_Text>
              </Select_Button>
            </Main_Content3>
          </Main_init_div4>
        </Main_div>

        {select === "" && select_pp === "" && (
          <>
            <Div_Null></Div_Null>
          </>
        )}

        {select === "앱/웹" && select_pp === "Dadem" && (
          <>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ justifyContent: "flex-start" }}>
                <Platform_Name>
                  <PP_Logo src={img_dadem_logo} alt={img_dadem_logo} />
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Main_Content4 $left>
                      <Content_Text $extra $xbold>
                        다댐
                      </Content_Text>
                    </Main_Content4>
                    <Main_Content4 $left>
                      <Content_Text $xlarge $gray>
                        다되는 예약제 대학배달앱
                      </Content_Text>
                    </Main_Content4>
                    <Main_init_div3
                      style={{
                        paddingTop: 0,
                        justifyContent: "flex-start",
                        marginTop: 10,
                      }}
                    >
                      <Gray_Box2>
                        <Content_Text $small $gray>
                          APP
                        </Content_Text>
                      </Gray_Box2>
                    </Main_init_div3>
                  </div>
                </Platform_Name>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_Bar />
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    서비스 설명
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text style={{ marginBottom: 40 }}>
                    모든 음식점 배달비 1,000원 배달앱 다댐입니다. 물품을 받을
                    위치와 시간을 설정하고 음식점을 선택하면 예약배달을 받을 수
                    있습니다. 배달의 실시간 현황을 확인 할 수 있으며 유저간의
                    실시간 채팅을 할 수 있습니다. 또한 관리자에게 문의가
                    가능하고 자유게시판을 통해 일상생활을 공유 할 수 있습니다.
                    다댐에 가맹된 음식점들의 가게 정보와 메뉴판 정보를 확인 할
                    수 있고 음식 배달에 대한 결제요청 및 결제가 가능합니다.
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    핵심 기능
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div style={{ paddingBottom: 10 }}>
              <Main_init_div
                style={{ justifyContent: "flex-start", paddingTop: 0 }}
              >
                <Gray_Box>
                  <Content_Text $small $gray>
                    로그인
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    푸쉬 알림
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    예약
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    채팅
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    QR
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    커뮤니티
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    결제
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    리뷰
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    문의
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    쿠폰
                  </Content_Text>
                </Gray_Box>
                <Gray_Box3 style={{ marginLeft: 15 }}>
                  <Content_Text $small $gray>
                    로그인
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    푸쉬 알림
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    예약
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    채팅
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    QR
                  </Content_Text>
                </Gray_Box3>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div
                style={{ justifyContent: "flex-start", paddingTop: 0 }}
              >
                <Gray_Box3 style={{ marginLeft: 15 }}>
                  <Content_Text $small $gray>
                    커뮤니티
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    결제
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    리뷰
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    문의
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    쿠폰
                  </Content_Text>
                </Gray_Box3>
              </Main_init_div>
            </Main_div>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ paddingTop: 50 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold style={{ marginBottom: 15 }}>
                    주요 화면
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div6>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dadem_info}
                  alt={img_dadem_info}
                />
              </Main_init_div>
            </Main_div6>
            <Main_div7>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "80%", cursor: "default" }}
                  src={img_dadem_info2}
                  alt={img_dadem_info2}
                />
              </Main_init_div>
            </Main_div7>
            <Main_div8>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dadem_info3}
                  alt={img_dadem_info3}
                />
              </Main_init_div>
            </Main_div8>
          </>
        )}

        {select === "앱/웹" && select_pp === "Petch" && (
          <>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ justifyContent: "flex-start" }}>
                <Platform_Name>
                  <PP_Logo src={img_petch_logo} alt={img_petch_logo} />
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Main_Content4 $left>
                      <Content_Text $extra $xbold>
                        펫치
                      </Content_Text>
                    </Main_Content4>
                    <Main_Content4 $left>
                      <Content_Text $xlarge $gray>
                        동물병원 진료비 검색할 땐?
                      </Content_Text>
                    </Main_Content4>
                    <Main_init_div3
                      style={{
                        paddingTop: 0,
                        justifyContent: "flex-start",
                        marginTop: 10,
                      }}
                    >
                      <Gray_Box2 style={{ marginRight: 5 }}>
                        <Content_Text $small $gray>
                          APP
                        </Content_Text>
                      </Gray_Box2>
                      <Gray_Box2>
                        <Content_Text $small $gray>
                          WEB
                        </Content_Text>
                      </Gray_Box2>
                    </Main_init_div3>
                  </div>
                </Platform_Name>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_Bar />
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    서비스 설명
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text style={{ marginBottom: 40 }}>
                    동물병원 진료비 조회 앱 펫치입니다. 동물병원의 정보와
                    진료비를 조회 할 수 있고, 궁금한 점이 있다면 1:1문의를 제출
                    할 수 있습니다. 만약 동물병원을 다녀오신 적이 있다면 평점을
                    줄 수 있으며 리뷰를 남길 수 있습니다. 내 주변에 있는
                    동물병원을 볼 수 있고 평점과 가격 정보로 비교 분석을 할 수
                    있습니다.
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    핵심 기능
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div style={{ paddingBottom: 10 }}>
              <Main_init_div
                style={{ justifyContent: "flex-start", paddingTop: 0 }}
              >
                <Gray_Box>
                  <Content_Text $small $gray>
                    로그인
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    푸쉬 알림
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    조회
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    문의
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    포인트
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    지도
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    리뷰
                  </Content_Text>
                </Gray_Box>

                <Gray_Box3 style={{ marginLeft: 15 }}>
                  <Content_Text $small $gray>
                    로그인
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    푸쉬 알림
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    조회
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    문의
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    포인트
                  </Content_Text>
                </Gray_Box3>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div
                style={{ justifyContent: "flex-start", paddingTop: 0 }}
              >
                <Gray_Box3 style={{ marginLeft: 15 }}>
                  <Content_Text $small $gray>
                    지도
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    리뷰
                  </Content_Text>
                </Gray_Box3>
              </Main_init_div>
            </Main_div>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ paddingTop: 50 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold style={{ marginBottom: 15 }}>
                    주요 화면
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div6>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_petch_info}
                  alt={img_petch_info}
                />
              </Main_init_div>
            </Main_div6>
            <Main_div7>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_petch_info2}
                  alt={img_petch_info2}
                />
              </Main_init_div>
            </Main_div7>
            <Main_div8>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_petch_info3}
                  alt={img_petch_info3}
                />
              </Main_init_div>
            </Main_div8>
          </>
        )}

        {select === "앱/웹" && select_pp === "Na" && (
          <>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ justifyContent: "flex-start" }}>
                <Platform_Name>
                  <PP_Logo src={img_na_logo} alt={img_na_logo} />
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Main_Content4 $left>
                      <Content_Text $extra $xbold>
                        뉴액터스
                      </Content_Text>
                    </Main_Content4>
                    <Main_Content4 $left>
                      <Content_Text $xlarge $gray>
                        단역, 보조출연을 하고싶다면?
                      </Content_Text>
                    </Main_Content4>
                    <Main_init_div3
                      style={{
                        paddingTop: 0,
                        justifyContent: "flex-start",
                      }}
                    >
                      <Gray_Box2>
                        <Content_Text $small $gray>
                          APP
                        </Content_Text>
                      </Gray_Box2>
                    </Main_init_div3>
                  </div>
                </Platform_Name>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_Bar />
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    서비스 설명
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text style={{ marginBottom: 40 }}>
                    출연모집공고를 볼 수 있는 앱 뉴액터스입니다. 원하는 지역의
                    단역,보조출연 모집공고를 확인할 수 있고 원하는 날짜의
                    모집공고에 지원할 수 있습니다. 내가 지원한 공고의 현재상태를
                    확인 할 수 있고 촬영이 시작된다면 촬영방에서 채팅을 할 수
                    있습니다.
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    핵심 기능
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div style={{ paddingBottom: 10 }}>
              <Main_init_div
                style={{ justifyContent: "flex-start", paddingTop: 0 }}
              >
                <Gray_Box>
                  <Content_Text $small $gray>
                    로그인
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    푸쉬 알림
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    예약
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    채팅
                  </Content_Text>
                </Gray_Box>

                <Gray_Box3 style={{ marginLeft: 15 }}>
                  <Content_Text $small $gray>
                    로그인
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    푸쉬 알림
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    예약
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    채팅
                  </Content_Text>
                </Gray_Box3>
              </Main_init_div>
            </Main_div>

            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ paddingTop: 50 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold style={{ marginBottom: 15 }}>
                    주요 화면
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div6>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_na_info}
                  alt={img_na_info}
                />
              </Main_init_div>
            </Main_div6>
            <Main_div7>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "80%", cursor: "default" }}
                  src={img_na_info2}
                  alt={img_na_info2}
                />
              </Main_init_div>
            </Main_div7>
            <Main_div8>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_na_info3}
                  alt={img_na_info3}
                />
              </Main_init_div>
            </Main_div8>
          </>
        )}

        {select === "앱/웹" && select_pp === "Naju" && (
          <>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ justifyContent: "flex-start" }}>
                <Platform_Name>
                  <PP_Logo src={img_naju_logo} alt={img_naju_logo} />
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Main_Content4 $left>
                      <Content_Text $xmlarge $xbold>
                        나주학생독립운동기념관 전자리플릿
                      </Content_Text>
                    </Main_Content4>
                    <Main_Content4 $left>
                      <Content_Text $xlarge $gray>
                        기념관 스탬프 투어
                      </Content_Text>
                    </Main_Content4>
                    <Main_init_div3
                      style={{
                        paddingTop: 0,
                        justifyContent: "flex-start",
                      }}
                    >
                      <Gray_Box2 style={{ marginRight: 5 }}>
                        <Content_Text $small $gray>
                          APP
                        </Content_Text>
                      </Gray_Box2>
                    </Main_init_div3>
                  </div>
                </Platform_Name>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_Bar />
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    서비스 설명
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text style={{ marginBottom: 40 }}>
                    기념관 스탬프투어 앱 나주학생운동독립기념관
                    전자리플릿입니다. 기념관의 전시물을 보면서 퀴즈도 풀고
                    선물도 받는 서비스입니다. 퀴즈는 전시물 주변에 배치된
                    QR코드를 인식하여 풀 수 있으며 정답을 맞추게 되면 무궁화
                    스탬프를 받게 됩니다. 퀴즈 참여 현황을 볼 수 있으며 문제
                    풀이에 따라 정답,오답이 표기됩니다.
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    핵심 기능
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div style={{ paddingBottom: 10 }}>
              <Main_init_div
                style={{ justifyContent: "flex-start", paddingTop: 0 }}
              >
                <Gray_Box>
                  <Content_Text $small $gray>
                    스탬프
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    QR
                  </Content_Text>
                </Gray_Box>
                <Gray_Box3 style={{ marginLeft: 15 }}>
                  <Content_Text $small $gray>
                    스탬프
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    QR
                  </Content_Text>
                </Gray_Box3>
              </Main_init_div>
            </Main_div>

            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ paddingTop: 50 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold style={{ marginBottom: 15 }}>
                    주요 화면
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div6>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_naju_info}
                  alt={img_naju_info}
                />
              </Main_init_div>
            </Main_div6>
            <Main_div7>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "80%", cursor: "default" }}
                  src={img_naju_info2}
                  alt={img_naju_info2}
                />
              </Main_init_div>
            </Main_div7>
            <Main_div8>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_naju_info3}
                  alt={img_naju_info3}
                />
              </Main_init_div>
            </Main_div8>
          </>
        )}
        {select === "앱/웹" && select_pp === "Rosepay" && (
          <>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ justifyContent: "flex-start" }}>
                <Platform_Name>
                  <PP_Logo src={img_rosepay_logo} alt={img_rosepay_logo} />
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Main_Content4 $left>
                      <Content_Text $extra $xbold>
                        로즈페이
                      </Content_Text>
                    </Main_Content4>
                    <Main_Content4 $left>
                      <Content_Text $xlarge $gray>
                        가맹점에서 10% 할인
                      </Content_Text>
                    </Main_Content4>
                    <Main_init_div3
                      style={{
                        paddingTop: 0,
                        justifyContent: "flex-start",
                        marginTop: 10,
                      }}
                    >
                      <Gray_Box2 style={{ marginRight: 5 }}>
                        <Content_Text $small $gray>
                          APP
                        </Content_Text>
                      </Gray_Box2>
                    </Main_init_div3>
                  </div>
                </Platform_Name>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_Bar />
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    서비스 설명
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text style={{ marginBottom: 40 }}>
                    모바일 온누리 상품권을 기반으로 하는 조선대 한정 결제
                    플랫폼입니다. 음식점이나 가게를 선택하여 QR 결제로 간편하게
                    결제할 수 있으며, 영업 중인 음식점을 선택하여 미리 주문하고
                    픽업할 수 있는 스마트오더 기능도 제공합니다.
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    핵심 기능
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div style={{ paddingBottom: 10 }}>
              <Main_init_div
                style={{ justifyContent: "flex-start", paddingTop: 0 }}
              >
                <Gray_Box>
                  <Content_Text $small $gray>
                    로그인
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    푸쉬 알림
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    포인트
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    QR
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    결제
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    주문
                  </Content_Text>
                </Gray_Box>
                <Gray_Box3 style={{ marginLeft: 15 }}>
                  <Content_Text $small $gray>
                    로그인
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    푸쉬 알림
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    포인트
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    QR
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    결제
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    주문
                  </Content_Text>
                </Gray_Box3>
              </Main_init_div>
            </Main_div>

            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ paddingTop: 50 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold style={{ marginBottom: 15 }}>
                    주요 화면
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div6>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_rosepay_info}
                  alt={img_rosepay_info}
                />
              </Main_init_div>
            </Main_div6>
            <Main_div7>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "80%", cursor: "default" }}
                  src={img_rosepay_info2}
                  alt={img_rosepay_info2}
                />
              </Main_init_div>
            </Main_div7>
            <Main_div8>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_rosepay_info3}
                  alt={img_rosepay_info3}
                />
              </Main_init_div>
            </Main_div8>
          </>
        )}
        {select === "앱/웹" && select_pp === "Naju_Train" && (
          <>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ justifyContent: "flex-start" }}>
                <Platform_Name>
                  <PP_Logo
                    src={img_naju_train_logo}
                    alt={img_naju_train_logo}
                  />
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Main_Content4 $left>
                      <Content_Text $xmlarge $xbold>
                        AI캐릭터봇을 활용한 역사 소개 프로그램
                      </Content_Text>
                    </Main_Content4>
                    <Main_Content4 $left>
                      <Content_Text $xlarge $gray>
                        역사 이야기 랜덤 뽑기
                      </Content_Text>
                    </Main_Content4>
                    <Main_init_div3
                      style={{
                        paddingTop: 0,
                        justifyContent: "flex-start",
                      }}
                    >
                      <Gray_Box2 style={{ marginRight: 5 }}>
                        <Content_Text $small $gray>
                          PROGRAM
                        </Content_Text>
                      </Gray_Box2>
                    </Main_init_div3>
                  </div>
                </Platform_Name>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_Bar />
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    서비스 설명
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text style={{ marginBottom: 40 }}>
                    AI캐릭터봇을 활용한 역사 소개 프로그램으로
                    나주학생독립운동의 사건의 발단이 되었던 구나주역을 배경으로
                    하였습니다. 구나주역 안에있는 증기기관차에서 이야기 뽑기를
                    누를시 랜덤으로 이야기가 나오는 랜덤 뽑기며, 이야기를 뽑았을
                    때 AI캐릭터봇이 음성과 글, 사진을 통해 역사를
                    안내해드립니다.
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    핵심 기능
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div style={{ paddingBottom: 10 }}>
              <Main_init_div
                style={{ justifyContent: "flex-start", paddingTop: 0 }}
              >
                <Gray_Box>
                  <Content_Text $small $gray>
                    뽑기
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    음성 해설
                  </Content_Text>
                </Gray_Box>

                <Gray_Box3 style={{ marginLeft: 15 }}>
                  <Content_Text $small $gray>
                    뽑기
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    음성 해설
                  </Content_Text>
                </Gray_Box3>
              </Main_init_div>
            </Main_div>

            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ paddingTop: 50 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold style={{ marginBottom: 15 }}>
                    주요 화면
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div6>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_naju_train_info}
                  alt={img_naju_train_info}
                />
              </Main_init_div>
            </Main_div6>
            <Main_div7>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "80%", cursor: "default" }}
                  src={img_naju_train_info2}
                  alt={img_naju_train_info2}
                />
              </Main_init_div>
            </Main_div7>
            <Main_div8>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_naju_train_info3}
                  alt={img_naju_train_info3}
                />
              </Main_init_div>
            </Main_div8>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ paddingTop: 50 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold style={{ marginBottom: 15 }}>
                    납품 사진
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div6>
              <Main_init_div
                style={{ paddingTop: 10, justifyContent: "flex-start" }}
              >
                <Image
                  style={{ width: "75%", cursor: "default" }}
                  src={img_naju_train_info_2}
                  alt={img_naju_train_info_2}
                />
              </Main_init_div>
            </Main_div6>
            <Main_div7>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "80%", cursor: "default" }}
                  src={img_naju_train_info2_2}
                  alt={img_naju_train_info2_2}
                />
              </Main_init_div>
            </Main_div7>
            <Main_div8>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_naju_train_info3_2}
                  alt={img_naju_train_info3_2}
                />
              </Main_init_div>
            </Main_div8>
          </>
        )}

        {select === "앱/웹" && select_pp === "GTP" && (
          <>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ justifyContent: "flex-start" }}>
                <Platform_Name>
                  <PP_Logo src={img_GTP_logo} alt={img_GTP_logo} />
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Main_Content4 $left>
                      <Content_Text $xmlarge $xbold>
                        광주학생탈렌트페스티벌 예약 및 투표 시스템
                      </Content_Text>
                    </Main_Content4>
                    <Main_Content4 $left>
                      <Content_Text $xlarge $gray>
                        페스티벌 예약 및 투표
                      </Content_Text>
                    </Main_Content4>
                    <Main_init_div3
                      style={{
                        paddingTop: 0,
                        justifyContent: "flex-start",
                      }}
                    >
                      <Gray_Box2 style={{ marginRight: 5 }}>
                        <Content_Text $small $gray>
                          WEB
                        </Content_Text>
                      </Gray_Box2>
                    </Main_init_div3>
                  </div>
                </Platform_Name>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_Bar />
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    서비스 설명
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text style={{ marginBottom: 40 }}>
                    광주광역시에서 진행되는 '광주학생탈렌트페스티벌'의 예약 및
                    투표 서비스입니다. 원하는 좌석을 선택, 예약 할 수 있고
                    페스티벌에 참가하는 팀들에 대해 투표를 진행 할 수 있습니다.
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    핵심 기능
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div style={{ paddingBottom: 10 }}>
              <Main_init_div
                style={{ justifyContent: "flex-start", paddingTop: 0 }}
              >
                <Gray_Box>
                  <Content_Text $small $gray>
                    예약
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    투표
                  </Content_Text>
                </Gray_Box>

                <Gray_Box3 style={{ marginLeft: 15 }}>
                  <Content_Text $small $gray>
                    예약
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    투표
                  </Content_Text>
                </Gray_Box3>
              </Main_init_div>
            </Main_div>

            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ paddingTop: 50 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold style={{ marginBottom: 15 }}>
                    주요 화면
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div6>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_GTP_info}
                  alt={img_GTP_info}
                />
              </Main_init_div>
            </Main_div6>
            <Main_div7>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "80%", cursor: "default" }}
                  src={img_GTP_info}
                  alt={img_GTP_info}
                />
              </Main_init_div>
            </Main_div7>
            <Main_div8>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_GTP_info}
                  alt={img_GTP_info}
                />
              </Main_init_div>
            </Main_div8>
            <Main_div6>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_GTP_info2}
                  alt={img_GTP_info2}
                />
              </Main_init_div>
            </Main_div6>
            <Main_div7>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "80%", cursor: "default" }}
                  src={img_GTP_info2}
                  alt={img_GTP_info2}
                />
              </Main_init_div>
            </Main_div7>
            <Main_div8>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_GTP_info2}
                  alt={img_GTP_info2}
                />
              </Main_init_div>
            </Main_div8>
            <Main_div6>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_GTP_info3}
                  alt={img_GTP_info3}
                />
              </Main_init_div>
            </Main_div6>
            <Main_div7>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "80%", cursor: "default" }}
                  src={img_GTP_info3}
                  alt={img_GTP_info3}
                />
              </Main_init_div>
            </Main_div7>
            <Main_div8>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_GTP_info3}
                  alt={img_GTP_info3}
                />
              </Main_init_div>
            </Main_div8>
            <Main_div6>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_GTP_info4}
                  alt={img_GTP_info4}
                />
              </Main_init_div>
            </Main_div6>
            <Main_div7>
              <Main_init_div style={{ paddingTop: 10 }}>
                <Image
                  style={{ width: "80%", cursor: "default" }}
                  src={img_GTP_info4}
                  alt={img_GTP_info4}
                />
              </Main_init_div>
            </Main_div7>
            <Main_div8>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_GTP_info4}
                  alt={img_GTP_info4}
                />
              </Main_init_div>
            </Main_div8>
          </>
        )}

        {select === "앱/웹" && select_pp === "Dron" && (
          <>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ justifyContent: "flex-start" }}>
                <Platform_Name>
                  <PP_Logo src={img_dron_logo} alt={img_dron_logo} />
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Main_Content4 $left>
                      <Content_Text $xmlarge $xbold>
                        드론평야
                      </Content_Text>
                    </Main_Content4>
                    <Main_Content4 $left>
                      <Content_Text $xlarge $gray>
                        농업 자동화 중계 서비스
                      </Content_Text>
                    </Main_Content4>
                    <Main_init_div3
                      style={{
                        paddingTop: 0,
                        justifyContent: "flex-start",
                      }}
                    >
                      <Gray_Box2 style={{ marginRight: 5 }}>
                        <Content_Text $small $gray>
                          WEB
                        </Content_Text>
                      </Gray_Box2>
                    </Main_init_div3>
                  </div>
                </Platform_Name>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_Bar />
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    서비스 설명
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text style={{ marginBottom: 40 }}>
                    광주광역시에서 진행되는 '광주학생탈렌트페스티벌'의 예약 및
                    투표 서비스입니다. 원하는 좌석을 선택, 예약 할 수 있고
                    페스티벌에 참가하는 팀들에 대해 투표를 진행 할 수 있습니다.
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    핵심 기능
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div style={{ paddingBottom: 10 }}>
              <Main_init_div
                style={{ justifyContent: "flex-start", paddingTop: 0 }}
              >
                <Gray_Box>
                  <Content_Text $small $gray>
                    예약
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    투표
                  </Content_Text>
                </Gray_Box>

                <Gray_Box3 style={{ marginLeft: 15 }}>
                  <Content_Text $small $gray>
                    예약
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    투표
                  </Content_Text>
                </Gray_Box3>
              </Main_init_div>
            </Main_div>

            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ paddingTop: 50 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold style={{ marginBottom: 15 }}>
                    주요 화면
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dron_info}
                  alt={img_dron_info}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dron_info2}
                  alt={img_dron_info2}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dron_info3}
                  alt={img_dron_info3}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dron_info4}
                  alt={img_dron_info4}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dron_info5}
                  alt={img_dron_info5}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dron_info6}
                  alt={img_dron_info6}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dron_info7}
                  alt={img_dron_info7}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dron_info8}
                  alt={img_dron_info8}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dron_info9}
                  alt={img_dron_info9}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dron_info10}
                  alt={img_dron_info10}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_dron_info11}
                  alt={img_dron_info11}
                />
              </Main_init_div>
            </Main_div>
          </>
        )}

        {select === "앱/웹" && select_pp === "Shopping" && (
          <>
            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ justifyContent: "flex-start" }}>
                <Platform_Name>
                  <PP_Logo src={img_shopping_logo} alt={img_shopping_logo} />
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Main_Content4 $left>
                      <Content_Text $xmlarge $xbold>
                        쇼핑핫딜
                      </Content_Text>
                    </Main_Content4>
                    <Main_Content4 $left>
                      <Content_Text $xlarge $gray>
                        라이브커머스
                      </Content_Text>
                    </Main_Content4>
                    <Main_init_div3
                      style={{
                        paddingTop: 0,
                        justifyContent: "flex-start",
                      }}
                    >
                      <Gray_Box2 style={{ marginRight: 5 }}>
                        <Content_Text $small $gray>
                          WEB
                        </Content_Text>
                      </Gray_Box2>
                    </Main_init_div3>
                  </div>
                </Platform_Name>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_Bar />
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    서비스 설명
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text style={{ marginBottom: 40 }}>
                    라이브로 진행되는 방송에서 실시간으로 상품을 구매할 수 있는
                    서비스입니다. 셀러는 라이브 방송 생성과 물품 판매, 재고관리,
                    주문관리 등을 할 수 있으며, 유저들은 실시간 채팅으로 셀러와
                    소통하며 원하는 물품을 구매할 수 있습니다.
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold>
                    핵심 기능
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div style={{ paddingBottom: 10 }}>
              <Main_init_div
                style={{ justifyContent: "flex-start", paddingTop: 0 }}
              >
                <Gray_Box>
                  <Content_Text $small $gray>
                    예약
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    투표
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    판매
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    라이브
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    재고관리
                  </Content_Text>
                </Gray_Box>
                <Gray_Box>
                  <Content_Text $small $gray>
                    주문관리
                  </Content_Text>
                </Gray_Box>

                <Gray_Box3 style={{ marginLeft: 15 }}>
                  <Content_Text $small $gray>
                    예약
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    투표
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    판매
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    라이브
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    재고관리
                  </Content_Text>
                </Gray_Box3>
                <Gray_Box3>
                  <Content_Text $small $gray>
                    주문관리
                  </Content_Text>
                </Gray_Box3>
              </Main_init_div>
            </Main_div>

            <Main_div style={{ paddingBottom: 0 }}>
              <Main_init_div style={{ paddingTop: 50 }}>
                <Main_Content $left>
                  <Content_Text $xlarge $xbold style={{ marginBottom: 15 }}>
                    주요 화면
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_shopping_info}
                  alt={img_shopping_info}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_shopping_info2}
                  alt={img_shopping_info2}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_shopping_info3}
                  alt={img_shopping_info3}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_shopping_info4}
                  alt={img_shopping_info4}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_shopping_info5}
                  alt={img_shopping_info5}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_shopping_info6}
                  alt={img_shopping_info6}
                />
              </Main_init_div>
            </Main_div>
            <Main_div>
              <Main_init_div style={{ padding: 15 }}>
                <Image
                  style={{ width: "100%", cursor: "default" }}
                  src={img_shopping_info7}
                  alt={img_shopping_info7}
                />
              </Main_init_div>
            </Main_div>
          </>
        )}

        {/* {select === "FMS" && select_pp === "FMS" && (
          <>
            <Main_div4 style={{ paddingBottom: 0 }}>
              <Main_init_div>
                <Image
                  style={{ width: 80, cursor: "default", marginRight: 20 }}
                  src={img_cns_mini}
                  alt={img_cns_mini}
                />
                <div>
                  <Main_Content $left>
                    <Content_Text $xlarge $gray>
                      FMS 시설관리시스템
                    </Content_Text>
                  </Main_Content>
                  <Main_Content $left style={{ marginTop: 10 }}>
                    <Content_Text $xxslarge $xbold>
                      CNS
                    </Content_Text>
                  </Main_Content>
                </div>
              </Main_init_div>
            </Main_div4>
            <Main_div4 style={{ paddingBottom: 0 }}>
              <FMS_Coment>
                <Content_Text $gray $small>
                  링크캠퍼스에서 제공하는 기본 플랫폼으로 제작한 FMS입니다.
                </Content_Text>
              </FMS_Coment>
            </Main_div4>
            <Main_div5>
              <Main_init_div
                style={{ justifyContent: "flex-start", marginLeft: 15 }}
              >
                <Image
                  style={{
                    width: 90,
                    cursor: "default",
                    marginRight: 10,
                  }}
                  src={img_cns_mini}
                  alt={img_cns_mini}
                />
                <div>
                  <Main_Content $left>
                    <Content_Text $xxslarge $xbold>
                      CNS
                    </Content_Text>
                  </Main_Content>
                  <Main_Content $left style={{ marginTop: 9 }}>
                    <Content_Text $xlarge $gray>
                      FMS 시설관리시스템
                    </Content_Text>
                  </Main_Content>
                  <Main_Content $left style={{ marginTop: 9 }}>
                    <FMS_Coment2>
                      <Content_Text $gray style={{ fontSize: 16 }}>
                        FMS
                      </Content_Text>
                    </FMS_Coment2>
                  </Main_Content>
                </div>
              </Main_init_div>
            </Main_div5>
            <Main_div5>
              <Main_Bar />
            </Main_div5>
            <Main_div5>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xmlarge $xbold style={{ marginBottom: 15 }}>
                    서비스 설명
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div5>
            <Main_div5>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text style={{ marginBottom: 40 }}>
                    링크캠퍼스에서 제공하는 기본 플랫폼으로 제작한 FMS입니다.
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div5>
            <Main_div5>
              <Main_init_div style={{ paddingTop: 0 }}>
                <Main_Content $left>
                  <Content_Text $xmlarge $xbold style={{ marginBottom: 15 }}>
                    주요 화면
                  </Content_Text>
                </Main_Content>
              </Main_init_div>
            </Main_div5>
            <Main_div5>
              <Mini_Main_Content style={{ marginLeft: 15, width: "100%" }}>
                <Mini_Image
                  onClick={() => {
                    set_Sel("01");
                  }}
                  src={sel === "01" ? img_Platform_1_sel : img_Platform_1}
                  alt={img_Platform_1}
                />
                <Mini_Image
                  onClick={() => {
                    set_Sel("04");
                  }}
                  src={sel === "04" ? img_Platform_4_sel : img_Platform_4}
                  alt={img_Platform_4}
                />
                <Mini_Image
                  onClick={() => {
                    set_Sel("07");
                  }}
                  src={sel === "07" ? img_Platform_7_sel : img_Platform_7}
                  alt={img_Platform_7}
                />
                <Mini_Image
                  onClick={() => {
                    set_Sel("10");
                  }}
                  src={sel === "10" ? img_Platform_10_sel : img_Platform_10}
                  alt={img_Platform_10}
                />
              </Mini_Main_Content>
              <Mini_Main_Content style={{ width: "100%" }}>
                <Mini_Image
                  onClick={() => {
                    set_Sel("02");
                  }}
                  src={sel === "02" ? img_Platform_2_sel : img_Platform_2}
                  alt={img_Platform_1}
                />
                <Mini_Image
                  onClick={() => {
                    set_Sel("05");
                  }}
                  src={sel === "05" ? img_Platform_5_sel : img_Platform_5}
                  alt={img_Platform_5}
                />
                <Mini_Image
                  onClick={() => {
                    set_Sel("08");
                  }}
                  src={sel === "08" ? img_Platform_8_sel : img_Platform_8}
                  alt={img_Platform_8}
                />
              </Mini_Main_Content>
              <Mini_Main_Content style={{ width: "100%" }}>
                <Mini_Image
                  onClick={() => {
                    set_Sel("03");
                  }}
                  src={sel === "03" ? img_Platform_3_sel : img_Platform_3}
                  alt={img_Platform_3}
                />
                <Mini_Image
                  onClick={() => {
                    set_Sel("06");
                  }}
                  src={sel === "06" ? img_Platform_6_sel : img_Platform_6}
                  alt={img_Platform_6}
                />
                <Mini_Image
                  onClick={() => {
                    set_Sel("09");
                  }}
                  src={sel === "09" ? img_Platform_9_sel : img_Platform_9}
                  alt={img_Platform_9}
                />
              </Mini_Main_Content>
            </Main_div5>
            <Main_div>
              <Select_div>
                <Main_Content>
                  <Image
                    onClick={() => {
                      set_Sel("01");
                    }}
                    src={sel === "01" ? img_Platform_1_sel : img_Platform_1}
                    alt={img_Platform_1}
                  />
                  <Image
                    onClick={() => {
                      set_Sel("06");
                    }}
                    src={sel === "06" ? img_Platform_6_sel : img_Platform_6}
                    alt={img_Platform_1}
                  />
                </Main_Content>
                <Main_Content>
                  <Image
                    onClick={() => {
                      set_Sel("02");
                    }}
                    src={sel === "02" ? img_Platform_2_sel : img_Platform_2}
                    alt={img_Platform_1}
                  />
                  <Image
                    onClick={() => {
                      set_Sel("07");
                    }}
                    src={sel === "07" ? img_Platform_7_sel : img_Platform_7}
                    alt={img_Platform_1}
                  />
                </Main_Content>
                <Main_Content>
                  <Image
                    onClick={() => {
                      set_Sel("03");
                    }}
                    src={sel === "03" ? img_Platform_3_sel : img_Platform_3}
                    alt={img_Platform_1}
                  />
                  <Image
                    onClick={() => {
                      set_Sel("08");
                    }}
                    src={sel === "08" ? img_Platform_8_sel : img_Platform_8}
                    alt={img_Platform_1}
                  />
                </Main_Content>
                <Main_Content>
                  <Image
                    onClick={() => {
                      set_Sel("04");
                    }}
                    src={sel === "04" ? img_Platform_4_sel : img_Platform_4}
                    alt={img_Platform_1}
                  />
                  <Image
                    onClick={() => {
                      set_Sel("09");
                    }}
                    src={sel === "09" ? img_Platform_9_sel : img_Platform_9}
                    alt={img_Platform_1}
                  />
                </Main_Content>
                <Main_Content>
                  <Image
                    onClick={() => {
                      set_Sel("05");
                    }}
                    src={sel === "05" ? img_Platform_5_sel : img_Platform_5}
                    alt={img_Platform_1}
                  />
                  <Image
                    onClick={() => {
                      set_Sel("10");
                    }}
                    src={sel === "10" ? img_Platform_10_sel : img_Platform_10}
                    alt={img_Platform_1}
                  />
                </Main_Content>
              </Select_div>
            </Main_div>
            <Main_div>
              <Main_Bar />
            </Main_div>
            <Title_div>
              <Content_Text $xbold $main>
                {sel}
              </Content_Text>
            </Title_div>
            <Title_div>
              <Content_Text $large $xbold $main>
                {sel === "01"
                  ? "계정관리"
                  : sel === "02"
                  ? "건축물 현황"
                  : sel === "03"
                  ? "보고서 관리"
                  : sel === "04"
                  ? "관리대장"
                  : sel === "05"
                  ? "보수비 및 집행실적"
                  : sel === "06"
                  ? "운영계획서"
                  : sel === "07"
                  ? "특별,정기점검"
                  : sel === "08"
                  ? "시설관리"
                  : sel === "09"
                  ? "교육 및 직원관리"
                  : "보험증권"}
              </Content_Text>
            </Title_div>
            {sel === "01" ? (
              <>
                <Image_div2>
                  <Image2 src={img_page1} alt={img_page1} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $gray>
                    여러 현장의 계정을 관리할 수 있습니다.
                  </Content_Text>
                </Text_div2>
              </>
            ) : sel === "02" ? (
              <>
                <Image_div2>
                  <Image2 src={img_page2} alt={img_page2} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    도면관리, 내역서 관리
                  </Content_Text>
                  <Content_Text $gray>
                    드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수
                    있습니다.
                  </Content_Text>
                </Text_div2>
              </>
            ) : sel === "03" ? (
              <>
                <Image_div2>
                  <Image2 src={img_page3} alt={img_page3} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    월말보고서, 분기보고서
                  </Content_Text>
                  <Content_Text $gray>
                    드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수
                    있습니다.
                  </Content_Text>
                </Text_div2>
              </>
            ) : sel === "04" ? (
              <>
                <Image_div2>
                  <Image2 $large src={img_page4_1} alt={img_page4_1} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    냉난방기, 보일러, 타일, 펌프 관리
                  </Content_Text>
                  <Content_Text $gray>
                    관리할 시설을 등록하고 자료 관리 및 다운로드가 가능합니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image2 $large src={img_page4_2} alt={img_page4_2} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    민원
                  </Content_Text>
                  <Content_Text $gray>
                    민원을 등록하고 관리 및 자료 출력이 가능합니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image2 $large src={img_page4_3} alt={img_page4_3} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    유형자산
                  </Content_Text>
                  <Content_Text $gray>
                    유형자산을 등록하고 관리 및 자료 다운로드가 가능합니다.
                  </Content_Text>
                </Text_div2>
              </>
            ) : sel === "05" ? (
              <>
                <Image_div2>
                  <Image2 src={img_page5_1} alt={img_page5_1} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    일상수선비, 장기수선충당금
                  </Content_Text>
                  <Content_Text $gray>
                    드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수
                    있습니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image2 $large src={img_page5_2} alt={img_page5_2} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    업체관리
                  </Content_Text>
                  <Content_Text $gray>
                    업체를 등록하고 관리할 수 있습니다.
                  </Content_Text>
                </Text_div2>
              </>
            ) : sel === "06" ? (
              <>
                <Image_div2>
                  <Image2 src={img_page6} alt={img_page6} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    운영계획서
                  </Content_Text>
                  <Content_Text $gray>
                    드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수
                    있습니다.
                  </Content_Text>
                </Text_div2>
              </>
            ) : sel === "07" ? (
              <>
                <Image_div2>
                  <Image2 src={img_page7} alt={img_page7} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    특별,정기점검
                  </Content_Text>
                  <Content_Text $gray>
                    드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수
                    있습니다.
                  </Content_Text>
                </Text_div2>
              </>
            ) : sel === "08" ? (
              <>
                <Image_div2>
                  <Image2 src={img_page8_1} alt={img_page8_1} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    점검일지
                  </Content_Text>
                  <Content_Text $gray>
                    시설 관련 점검일지, 근무일지 등 점검사항을 등록하고 관리할
                    수 있습니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image2 src={img_page8_2} alt={img_page8_2} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    점검일지 {">"} 점검일지 등록
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image2 $large src={img_page8_3} alt={img_page8_3} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    일반수선 관리
                  </Content_Text>
                  <Content_Text $gray>
                    일반수선 사항을 등록하고 관리 및 자료 출력이 가능합니다.
                  </Content_Text>
                </Text_div2>
              </>
            ) : sel === "09" ? (
              <>
                <Image_div2>
                  <Image2 src={img_page9_1} alt={img_page9_1} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    교육일지, 자격관리
                  </Content_Text>
                  <Content_Text $gray>
                    드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수
                    있습니다.
                  </Content_Text>
                </Text_div2>
                <Image_div2>
                  <Image2 $large src={img_page9_2} alt={img_page9_2} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    출퇴근관리
                  </Content_Text>
                  <Content_Text $gray>
                    출퇴근 관리를 할 수 있습니다.
                  </Content_Text>
                </Text_div2>
              </>
            ) : sel === "10" ? (
              <>
                <Image_div2>
                  <Image2 src={img_page10} alt={img_page10} />
                </Image_div2>
                <Text_div2>
                  <Content_Text $large $bold>
                    보험증권
                  </Content_Text>
                  <Content_Text $gray>
                    드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수
                    있습니다.
                  </Content_Text>
                </Text_div2>
              </>
            ) : (
              <Main_div>
                <Image2 src={img_main_mid} alt={img_main_mid} />
              </Main_div>
            )}
          </>
        )} */}
      </Main>
      <Footer>
        <Footer_FMS />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
    </Container>
  );
}

export default Platform_Info;
